<template>
  <div class="header_right">
    <div class="function">
      <div
        class="item_fun"
        v-for="(item, index) in imgFun"
        :key="index"
        :class="funIndex == index ? 'item_fun_ac' : ''"
        @click="funInteraction(index, item)"
      >
        <img :src="item.img" :title="item.text" />
      </div>
    </div>
    <Clock />
    <div class="user"></div>
  </div>
</template>

<script>
import Clock from './Clock.vue'
import { mapState } from 'vuex'
export default {
  components: {
    Clock
  },
  props: {
    weatherHeight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['spaceLevel'])
  },
  data() {
    return {
      imgFun: [
        {
          img: require('../../assets/img/layout/zhishu.png'),
          text: '数据分析'
        },
        {
          img: require('../../assets/img/layout/yingyong.png'),
          text: '对象管理'
        },
        {
          img: require('../../assets/img/layout/gaojing.png'),
          text: '实时告警'
        },
        {
          img: require('../../assets/img/layout/search.png'),
          text: '高级搜索'
        },
        {
          img: require('../../assets/img/layout/view.png'),
          text: '演示汇报'
        },
        {
          img: require('../../assets/img/layout/earth.png'),
          text: '返回地球'
        }
      ],
      funIndex: -1
    }
  },
  methods: {
    funInteraction(index, item) {
      if (index == 5) {
        this.funIndex = -1
        this.$emit('interaction', '返回地球')
        return
      }
      if (index == this.funIndex) {
        this.funIndex = -1
      } else {
        if (index == 3) {
          if (this.spaceLevel == '机柜组机房' || this.spaceLevel == '楼层'|| this.spaceLevel == '机柜组') {
            this.funIndex = index
          } else {
            return
          }
        }
        this.funIndex = index
      }
      this.$emit('interaction', this.funIndex >= 0 ? item.text : '默认状态')
    }
  }
}
</script>

<style lang="less" scoped>
.header_right {
  width: 890px;
  height: 100px;
  display: flex;
  position: absolute;
  right: 20px;
  top: 0px;
  .function {
    display: flex;
    height: 100px;
    .item_fun {
      width: 80px;
      line-height: 100px;
      position: relative;
      text-align: center;
      img {
        vertical-align: middle;
      }
    }
    .item_fun::after {
      content: '';
      display: block;
      width: 2px;
      height: 60px;
      position: absolute;
      top: 20px;
      right: 2px;
      background-color: #ffffff25;
    }
    .item_fun_ac {
      background: #189bfa;
    }
  }
  .user {
    width: 240px;
    height: 100px;
    background: url('../../assets/img/layout/admin.png') no-repeat center center;
  }
}
</style>
